import { MasterButton, Modal, InputTextArea } from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useContext, useState } from "react";
import { FormContext } from "../../context/FormContext";
import {
  defaultToastSuccess,
  defaultToastError,
  isNull,
  toUTCFormat,
} from "App/utils/helpers";
import {
  DISABLED_BUTTON_SUBMIT,
  instance4,
  WMS_FA_REQUEST,
} from "App/constants";
import {
  STATUS_TRANSAKSI_DRAFT,
  STATUS_TRANSAKSI_PENGAJUAN,
  STATUS_TRANSAKSI_DISETUJUI,
  STATUS_TRANSAKSI_PENAWARAN,
  STATUS_TRANSAKSI_TRIAL,
  STATUS_TRANSAKSI_PENGAJUAN_PO,
  STATUS_TRANSAKSI_PENGADAAN,
  STATUS_TRANSAKSI_REJECT,
  STATUS_TRANSAKSI_REVISI,
  STATUS_TRANSAKSI_SELESAI,
  urlCreateREQ,
  urlUpdateREQ,
  urlVerifikasiTransaksi,
} from "../../helpers";

const SHOW_OPEN_DRAFT = {
  label: "OPEN DRAFT",
  color: "lightgreen",
  state: true,
  disabled: false,
};

export const SHOW_AJUKAN = {
  label: "PENGAJUAN",
  color: "lightgreen",
  state: true,
  disabled: false,
};

export const SHOW_DISETUJUI = {
  label: "SETUJUI",
  color: "green",
  state: true,
  disabled: false,
};

export const SHOW_PENAWARAN = {
  label: "PENAWARAN",
  color: "green",
  state: true,
  disabled: false,
};

export const SHOW_TRIAL = {
  label: "TRIAL",
  color: "green",
  state: true,
  disabled: false,
};

export const SHOW_PENGAJUAN_PO = {
  label: "PENGAJUAN PO",
  color: "green",
  state: true,
  disabled: false,
};

export const SHOW_PENGADAAN = {
  label: "PENGADAAN",
  color: "green",
  state: true,
  disabled: false,
};

export const SHOW_TOLAK = {
  label: "TOLAK",
  color: "danger",
  state: true,
  disabled: false,
};

export const SHOW_UPDATE = {
  label: "UPDATE",
  color: "green",
  state: true,
  disabled: false,
};

export const SHOW_REVISI = {
  label: "REVISI",
  color: "warning",
  state: true,
  disabled: false,
};

export const SHOW_SELESAI = {
  label: "SELESAI",
  color: "green",
  state: true,
  disabled: false,
};

const ModalSimpan = ({
  setShowModal,
  resetForm,
  setNewDataReqList,
  listREQ,
  setListREQ,
}) => {
  const [disabledOpenDraft, setDisabledOpenDraft] = useState(SHOW_OPEN_DRAFT);
  const [disabledUpdate, setDisabledUpdate] = useState(SHOW_UPDATE);
  const [disabledAjukan, setDisabledAjukan] = useState(SHOW_AJUKAN);
  const [disabledDisetujui, setDisabledDisetujui] = useState(SHOW_DISETUJUI);
  const [disabledPenawaran, setDisabledPenawaran] = useState(SHOW_PENAWARAN);
  const [disabledTrial, setDisabledTrial] = useState(SHOW_TRIAL);
  const [disabledPengadaan, setDisabledPengadaan] = useState(SHOW_PENGAJUAN_PO);
  const [disabledTolak, setDisabledTolak] = useState(SHOW_TOLAK);
  const [disabledRevisi, setDisabledRevisi] = useState(SHOW_REVISI);
  const [disabledSelesai, setDisabledSelesai] = useState(SHOW_SELESAI);
  const { validasi } = useContext(FormContext);

  const { formData, setFormData } = useContext(FormContext);

  const handleClickOpenDraf = async (e) => {
    e.preventDefault();
    setDisabledOpenDraft(DISABLED_BUTTON_SUBMIT);
    try {
      if (
        formData.date === "" ||
        isNull(formData.nama) ||
        isNull(formData.unit_id) ||
        isNull(formData.status_kebutuhan) ||
        isNull(formData.user_request)
      ) {
        defaultToastError("Harap lengkapi form input request !");
        setDisabledOpenDraft(SHOW_OPEN_DRAFT);
      } else {
        const api = await instance4.post(urlCreateREQ, {
          name: formData.nama,
          status_kebutuhan: formData.status_kebutuhan,
          status: true,
          unit_id: formData.unit_id,
          remark: formData.remark,
          tgl_permintaan: toUTCFormat(formData.date),
          user_request: formData.user_request,
          detail: listREQ,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          await setFormData({
            ...formData,
            idreq: res.data.id,
            isOpenDraf: true,
            isProcess: false,
          });
          await setListREQ(res.data.detail_req);
          setNewDataReqList(res.data.id);
        } else {
          setDisabledOpenDraft(SHOW_OPEN_DRAFT);
          defaultToastError(res?.message);
        }
      }
    } catch (error) {
      setDisabledOpenDraft(SHOW_OPEN_DRAFT);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickUpdate = async (e) => {
    e.preventDefault();
    setDisabledUpdate(DISABLED_BUTTON_SUBMIT);
    try {
      if (formData.date === "") {
        defaultToastError("Tanggal tidak boleh kosong!");
        setDisabledUpdate(SHOW_UPDATE);
      } else {
        const api = await instance4.post(urlUpdateREQ, {
          id: formData.idreq,
          name: formData.nama,
          status_kebutuhan: formData.status_kebutuhan,
          status: true,
          unit_id: formData.unit_id,
          remark: formData.remark,
          tgl_permintaan: toUTCFormat(formData.date),
          user_request: formData.user_request,
          detail: listREQ,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          await setListREQ(res.data.detail_req);
          defaultToastSuccess(res?.message);
          setNewDataReqList(formData.idreq);
        } else {
          defaultToastError(res?.message);
        }
        setDisabledUpdate(SHOW_UPDATE);
      }
    } catch (error) {
      setDisabledUpdate(SHOW_UPDATE);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickAjukan = async (e) => {
    e.preventDefault();
    setDisabledAjukan(DISABLED_BUTTON_SUBMIT);
    try {
      if (formData.date === "") {
        defaultToastError("Tanggal tidak boleh kosong!");
        setDisabledAjukan(SHOW_AJUKAN);
      } else {
        const api = await instance4.post(urlVerifikasiTransaksi, {
          id: formData.idreq,
          status_verifikasi: STATUS_TRANSAKSI_PENGAJUAN,
          remak_verifikasi: formData.remark_verifikasi2,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          await setFormData({
            ...formData,
            remak_verifikasi: formData.remark_verifikasi2,
            status_verifikasi: STATUS_TRANSAKSI_PENGAJUAN,
            isOpenDraf: false,
            isProcess: true,
          });
          setNewDataReqList(formData.idreq);
        } else {
          defaultToastError(res?.message);
        }
        setDisabledAjukan(SHOW_AJUKAN);
      }
    } catch (error) {
      setDisabledAjukan(SHOW_AJUKAN);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickDisetujui = async (e) => {
    e.preventDefault();
    setDisabledDisetujui(DISABLED_BUTTON_SUBMIT);
    if (validasi) {
      try {
        if (formData.date === "") {
          defaultToastError("Tanggal tidak boleh kosong!");
          setDisabledDisetujui(SHOW_DISETUJUI);
        } else {
          const api = await instance4.post(urlVerifikasiTransaksi, {
            id: formData.idreq,
            status_verifikasi: STATUS_TRANSAKSI_DISETUJUI,
            remak_verifikasi: formData.remark_verifikasi2,
          });
          const res = await api?.data;
          if (res.status === 200) {
            setShowModal(false);
            defaultToastSuccess(res?.message);
            await setFormData({
              ...formData,
              remak_verifikasi: formData.remark_verifikasi2,
              status_verifikasi: STATUS_TRANSAKSI_DISETUJUI,
              isOpenDraf: false,
              isProcess: true,
            });
            setNewDataReqList(formData.idreq);
          } else {
            defaultToastError(res?.message);
          }
          setDisabledDisetujui(SHOW_DISETUJUI);
        }
      } catch (error) {
        setDisabledDisetujui(SHOW_DISETUJUI);
        defaultToastError(error?.response?.data?.message);
      }
    } else {
      setDisabledDisetujui(SHOW_DISETUJUI);
      defaultToastError("Anda tidak memiliki akses untuk menyetujui!");
    }
  };

  const handleClickPenawaran = async (e) => {
    e.preventDefault();
    setDisabledPenawaran(DISABLED_BUTTON_SUBMIT);
    if (validasi) {
      const barang = listREQ;
      const checkBarang = barang.filter((e) => e.status_cek_barang === null);
      if (checkBarang.length === 0) {
        try {
          if (formData.date === "") {
            defaultToastError("Tanggal tidak boleh kosong!");
            setDisabledPenawaran(SHOW_PENAWARAN);
          } else {
            const api = await instance4.post(urlVerifikasiTransaksi, {
              id: formData.idreq,
              status_verifikasi: STATUS_TRANSAKSI_PENAWARAN,
              remak_verifikasi: formData.remark_verifikasi2,
              kode_menu: WMS_FA_REQUEST,
              nama_menu: "Input Request",
            });
            const res = await api?.data;
            if (res.status === 200) {
              setShowModal(false);
              defaultToastSuccess(res?.message);
              await setFormData({
                ...formData,
                remak_verifikasi: formData.remark_verifikasi2,
                status_verifikasi: STATUS_TRANSAKSI_PENAWARAN,
                isOpenDraf: false,
                isProcess: true,
              });
              setNewDataReqList(formData.idreq);
            } else {
              defaultToastError(res?.message);
            }
            setDisabledPenawaran(SHOW_PENAWARAN);
          }
        } catch (error) {
          setDisabledPenawaran(SHOW_PENAWARAN);
          defaultToastError(error?.response?.data?.message);
        }
      } else {
        setDisabledPenawaran(SHOW_PENAWARAN);
        defaultToastError(
          "Tidak dapat melanjutkan, masih terdapat barang yang berstatus PENGAJUAN !"
        );
      }
    } else {
      setDisabledDisetujui(SHOW_DISETUJUI);
      defaultToastError("Anda tidak memiliki akses untuk melakukan penawaran!");
    }
  };

  const handleClickTrial = async (e) => {
    e.preventDefault();
    setDisabledTrial(DISABLED_BUTTON_SUBMIT);
    if (validasi) {
      try {
        if (formData.date === "") {
          defaultToastError("Tanggal tidak boleh kosong!");
          setDisabledTrial(SHOW_TRIAL);
        } else {
          const api = await instance4.post(urlVerifikasiTransaksi, {
            id: formData.idreq,
            status_verifikasi: STATUS_TRANSAKSI_TRIAL,
            remak_verifikasi: formData.remark_verifikasi2,
            kode_menu: WMS_FA_REQUEST,
            nama_menu: "Input Request",
          });
          const res = await api?.data;
          if (res.status === 200) {
            setShowModal(false);
            defaultToastSuccess(res?.message);
            await setFormData({
              ...formData,
              remak_verifikasi: formData.remark_verifikasi2,
              status_verifikasi: STATUS_TRANSAKSI_TRIAL,
              isOpenDraf: false,
              isProcess: true,
            });
            setNewDataReqList(formData.idreq);
          } else {
            defaultToastError(res?.message);
          }
          setDisabledTrial(SHOW_TRIAL);
        }
      } catch (error) {
        setDisabledTrial(SHOW_TRIAL);
        defaultToastError(error?.response?.data?.message);
      }
    } else {
      setDisabledTrial(SHOW_TRIAL);
      defaultToastError("Anda tidak memiliki akses untuk menyetujui!");
    }
  };

  const handleClickPengajuanPO = async (e) => {
    e.preventDefault();
    setDisabledPengadaan(DISABLED_BUTTON_SUBMIT);
    if (validasi) {
      try {
        if (formData.date === "") {
          defaultToastError("Tanggal tidak boleh kosong!");
          setDisabledPengadaan(SHOW_PENGAJUAN_PO);
        } else {
          const api = await instance4.post(urlVerifikasiTransaksi, {
            id: formData.idreq,
            status_verifikasi: STATUS_TRANSAKSI_PENGAJUAN_PO,
            remak_verifikasi: formData.remark_verifikasi2,
            kode_menu: WMS_FA_REQUEST,
            nama_menu: "Input Request",
          });
          const res = await api?.data;
          if (res.status === 200) {
            setShowModal(false);
            defaultToastSuccess(res?.message);
            await setFormData({
              ...formData,
              remak_verifikasi: formData.remark_verifikasi2,
              status_verifikasi: STATUS_TRANSAKSI_PENGAJUAN_PO,
              isOpenDraf: false,
              isProcess: true,
            });
            setNewDataReqList(formData.idreq);
          } else {
            defaultToastError(res?.message);
          }
          setDisabledPengadaan(SHOW_PENGAJUAN_PO);
        }
      } catch (error) {
        setDisabledPengadaan(SHOW_PENGAJUAN_PO);
        defaultToastError(error?.response?.data?.message);
      }
    } else {
      setDisabledPengadaan(SHOW_PENGAJUAN_PO);
      defaultToastError("Anda tidak memiliki akses !");
    }
  };

  const handleClickSelesai = async (e) => {
    e.preventDefault();
    setDisabledSelesai(DISABLED_BUTTON_SUBMIT);
    if (validasi) {
      try {
        if (formData.date === "") {
          defaultToastError("Tanggal tidak boleh kosong!");
          setDisabledSelesai(SHOW_SELESAI);
        } else {
          const api = await instance4.post(urlVerifikasiTransaksi, {
            id: formData.idreq,
            status_verifikasi: STATUS_TRANSAKSI_SELESAI,
            remak_verifikasi: formData.remark_verifikasi2,
            kode_menu: WMS_FA_REQUEST,
            nama_menu: "Input Request",
          });
          const res = await api?.data;
          if (res.status === 200) {
            setShowModal(false);
            defaultToastSuccess(res?.message);
            await setFormData({
              ...formData,
              remak_verifikasi: formData.remark_verifikasi2,
              status_verifikasi: STATUS_TRANSAKSI_SELESAI,
              isOpenDraf: false,
              isProcess: true,
            });
            setNewDataReqList(formData.idreq);
          } else {
            defaultToastError(res?.message);
          }
          setDisabledSelesai(SHOW_SELESAI);
        }
      } catch (error) {
        setDisabledSelesai(SHOW_SELESAI);
        defaultToastError(error?.response?.data?.message);
      }
    } else {
      setDisabledSelesai(SHOW_SELESAI);
      defaultToastError(
        "Anda tidak memiliki akses untuk menyelesaikan permintaan!"
      );
    }
  };

  const handleClickTolak = async (e) => {
    e.preventDefault();
    setDisabledTolak(DISABLED_BUTTON_SUBMIT);
    if (validasi) {
      try {
        if (formData.date === "") {
          defaultToastError("Tanggal tidak boleh kosong!");
          setDisabledTolak(SHOW_TOLAK);
        } else {
          const api = await instance4.post(urlVerifikasiTransaksi, {
            id: formData.idreq,
            status_verifikasi: STATUS_TRANSAKSI_REJECT,
            remak_verifikasi: formData.remark_verifikasi2,
            kode_menu: WMS_FA_REQUEST,
            nama_menu: "Input Request",
          });
          const res = await api?.data;
          if (res.status === 200) {
            setShowModal(false);
            defaultToastSuccess(res?.message);
            await setFormData({
              ...formData,
              remak_verifikasi: formData.remark_verifikasi2,
              status_verifikasi: STATUS_TRANSAKSI_REJECT,
              isOpenDraf: false,
              isProcess: true,
            });
            setNewDataReqList(formData.idreq);
          } else {
            defaultToastError(res?.message);
          }
          setDisabledTolak(SHOW_TOLAK);
        }
      } catch (error) {
        setDisabledTolak(SHOW_TOLAK);
        defaultToastError(error?.response?.data?.message);
      }
    } else {
      setDisabledTolak(SHOW_TOLAK);
      defaultToastError("Anda tidak memiliki akses untuk menolak permintaan!");
    }
  };

  const handleClickRevisi = async (e) => {
    e.preventDefault();
    setDisabledRevisi(DISABLED_BUTTON_SUBMIT);
    if (validasi) {
      try {
        if (formData.date === "") {
          defaultToastError("Tanggal tidak boleh kosong!");
          setDisabledRevisi(SHOW_REVISI);
        } else {
          const api = await instance4.post(urlVerifikasiTransaksi, {
            id: formData.idreq,
            status_verifikasi: STATUS_TRANSAKSI_REVISI,
            remak_verifikasi: formData.remark_verifikasi2,
            kode_menu: WMS_FA_REQUEST,
            nama_menu: "Input Request",
          });
          const res = await api?.data;
          if (res.status === 200) {
            setShowModal(false);
            defaultToastSuccess(res?.message);
            await setFormData({
              ...formData,
              remak_verifikasi: formData.remark_verifikasi2,
              status_verifikasi: STATUS_TRANSAKSI_REVISI,
              isOpenDraf: true,
              isProcess: false,
            });
            setNewDataReqList(formData.idreq);
          } else {
            defaultToastError(res?.message);
          }
          setDisabledRevisi(SHOW_REVISI);
        }
      } catch (error) {
        setDisabledRevisi(SHOW_REVISI);
        defaultToastError(error?.response?.data?.message);
      }
    } else {
      setDisabledRevisi(SHOW_REVISI);
      defaultToastError("Anda tidak memiliki akses untuk merevisi permintaan!");
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };
  return (
    <Modal title={"Simpan"} show={setShowModal}>
      <Grid
        container
        direction="row"
        alignItems="center"
        style={{ marginBottom: "1rem" }}
      >
        {formData.status_verifikasi === STATUS_TRANSAKSI_PENGAJUAN ||
        formData.status_verifikasi === STATUS_TRANSAKSI_DISETUJUI ||
        formData.status_verifikasi === STATUS_TRANSAKSI_PENAWARAN ||
        formData.status_verifikasi === STATUS_TRANSAKSI_TRIAL ? (
          <InputTextArea
            id="remark_verifikasi"
            label={"Keterangan/Catatan"}
            name=""
            className="w-full"
            value={formData.remark_verifikasi2}
            placeholder={""}
            onChange={handleChange("remark_verifikasi2")}
            rows={"3"}
          />
        ) : (
          <></>
        )}
        <ButtonCreate
          isOpenDraf={formData.isOpenDraf}
          isProcess={formData.isProcess}
          formData={formData}
          disabledOpenDraft={disabledOpenDraft}
          disabledUpdate={disabledUpdate}
          disabledAjukan={disabledAjukan}
          disabledPenawaran={disabledPenawaran}
          disabledTrial={disabledTrial}
          disabledPengadaan={disabledPengadaan}
          disabledDisetujui={disabledDisetujui}
          disabledTolak={disabledTolak}
          disabledRevisi={disabledRevisi}
          disabledSelesai={disabledSelesai}
          handleClickOpenDraf={handleClickOpenDraf}
          handleClickUpdate={handleClickUpdate}
          handleClickAjukan={handleClickAjukan}
          handleClickDisetujui={handleClickDisetujui}
          handleClickPenawaran={handleClickPenawaran}
          handleClickTrial={handleClickTrial}
          handleClickPengajuanPO={handleClickPengajuanPO}
          handleClickSelesai={handleClickSelesai}
          handleClickTolak={handleClickTolak}
          handleClickRevisi={handleClickRevisi}
        />
      </Grid>
    </Modal>
  );
};

const ButtonCreate = ({
  isOpenDraf,
  isProcess,
  formData,
  disabledOpenDraft,
  disabledUpdate,
  disabledAjukan,
  disabledPenawaran,
  disabledTrial,
  disabledPengadaan,
  disabledDisetujui,
  disabledTolak,
  disabledRevisi,
  disabledSelesai,
  handleClickOpenDraf,
  handleClickUpdate,
  handleClickAjukan,
  handleClickDisetujui,
  handleClickPenawaran,
  handleClickTrial,
  handleClickPengajuanPO,
  handleClickSelesai,
  handleClickTolak,
  handleClickRevisi,
}) => {
  return (
    <>
      {(isOpenDraf && !isNull(formData.idreq)) ||
      (!isOpenDraf && !isNull(formData.idreq)) ? (
        formData.status_verifikasi === STATUS_TRANSAKSI_PENGAJUAN ? (
          <>
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledDisetujui.color}
              onClick={(e) => disabledDisetujui.disabled ? null : handleClickDisetujui(e)}
              name={disabledDisetujui.label}
              size="lg"
            />
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledRevisi.color}
              onClick={(e) => disabledRevisi.disabled ? null : handleClickRevisi(e)}
              name={disabledRevisi.label}
              size="lg"
            />
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledTolak.color}
              onClick={(e) => disabledTolak.disabled ? null : handleClickTolak(e)}
              name={disabledTolak.label}
              size="lg"
            />
          </>
        ) : formData.status_verifikasi === STATUS_TRANSAKSI_DRAFT ||
          formData.status_verifikasi === STATUS_TRANSAKSI_REVISI ? (
          <>
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledAjukan.color}
              onClick={(e) => disabledAjukan.disabled ? null : handleClickAjukan(e)}
              name={disabledAjukan.label}
              size="lg"
            />
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledUpdate.color}
              onClick={(e) => disabledUpdate.disabled ? null : handleClickUpdate(e)}
              name={disabledUpdate.label}
              size="lg"
            />
          </>
        ) : formData.status_verifikasi === STATUS_TRANSAKSI_DISETUJUI ? (
          <>
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledPenawaran.color}
              onClick={(e) => disabledPenawaran.disabled ? null : handleClickPenawaran(e)}
              name={disabledPenawaran.label}
              size="lg"
            />
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledRevisi.color}
              onClick={(e) => disabledRevisi.disabled ? null : handleClickRevisi(e)}
              name={disabledRevisi.label}
              size="lg"
            />
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledTolak.color}
              onClick={(e) => disabledTolak.disabled ? null : handleClickTolak(e)}
              name={disabledTolak.label}
              size="lg"
            />
          </>
        ) : formData.status_verifikasi === STATUS_TRANSAKSI_PENAWARAN ? (
          <>
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledTrial.color}
              onClick={(e) => disabledTrial.disabled ? null : handleClickTrial(e)}
              name={disabledTrial.label}
              size="lg"
            />
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledRevisi.color}
              onClick={(e) => disabledRevisi.disabled ? null : handleClickRevisi(e)}
              name={disabledRevisi.label}
              size="lg"
            />
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledTolak.color}
              onClick={(e) => disabledTolak.disabled ? null : handleClickTolak(e)}
              name={disabledTolak.label}
              size="lg"
            />
          </>
        ) : formData.status_verifikasi === STATUS_TRANSAKSI_TRIAL ? (
          <>
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledPengadaan.color}
              onClick={(e) => disabledPengadaan.disabled ? null : handleClickPengajuanPO(e)}
              name={disabledPengadaan.label}
              size="lg"
            />
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledRevisi.color}
              onClick={(e) => disabledRevisi.disabled ? null : handleClickRevisi(e)}
              name={disabledRevisi.label}
              size="lg"
            />
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledTolak.color}
              onClick={(e) => disabledTolak.disabled ? null : handleClickTolak(e)}
              name={disabledTolak.label}
              size="lg"
            />
          </>
        ) : formData.status_verifikasi === STATUS_TRANSAKSI_PENGAJUAN_PO ? (
          <>
            <div style={{ textAlign: "center", width: "100%" }}>
              <>TRANSAKSI DALAM PROSES PENGAJUAN PO</>
            </div>
            {/* <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledSelesai.color}
              onClick={(e) => handleClickSelesai(e)}
              name={disabledSelesai.label}
              size="lg"
            /> */}
          </>
        ) : formData.status_verifikasi === STATUS_TRANSAKSI_PENGADAAN ? (
          <>
            <div style={{ textAlign: "center", width: "100%" }}>
              <>TRANSAKSI DALAM PROSES PURCHASE ORDER</>
            </div>
            {/* <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledSelesai.color}
              onClick={(e) => handleClickSelesai(e)}
              name={disabledSelesai.label}
              size="lg"
            /> */}
          </>
        ) : formData.status_verifikasi === STATUS_TRANSAKSI_SELESAI ? (
          <div style={{ textAlign: "center", width: "100%" }}>
            <>TRANSAKSI TELAH SELESAI</>
          </div>
        ) : (
          <div style={{ textAlign: "center", width: "100%" }}>
            <>TRANSAKSI DITOLAK</>
          </div>
        )
      ) : (
        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          color={disabledOpenDraft.color}
          name={disabledOpenDraft.label}
          onClick={(e) => disabledOpenDraft.disabled ? null : handleClickOpenDraf(e)}
          size="lg"
        />
      )}
    </>
  );
};

export default ModalSimpan;
